import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { ApplicationState } from '../..';
import { Grid, Segment, Table, Header, Icon } from 'semantic-ui-react';
import { datetimeFormatter, decimalFormatter } from '../../core/utility';
import * as Contributi from '../../contributi';
import { Contributo, ImportoContributo } from '../models';

const connector = connect(
    (state: ApplicationState) => state => ({ 
        ...state.contributi, 
        lingua: state.core.lingua,
        anagrafica: state.core.anagrafiche.anagrafica!,
    }),
    Contributi.actions
)
type PropsFromRedux = ConnectedProps<typeof connector>

type InScadenzaProps = PropsFromRedux

class InScadenza extends React.Component<InScadenzaProps> {
    constructor(props: InScadenzaProps) {
        super(props);

        this.renderContributi = this.renderContributi.bind(this);
        this.renderContributo = this.renderContributo.bind(this);
        this.renderContributoBody = this.renderContributoBody.bind(this);
        this.renderImportiContributo = this.renderImportiContributo.bind(this);
        this.renderImportoContributo = this.renderImportoContributo.bind(this);
    }

    componentDidMount() {
        this.props.requestContributiInScadenza();
    }

    render() {
        const { anagrafica } = this.props;

        return (
            <Grid centered columns='equal'>
                <Grid.Row>
                    <Header as='h2' dividing>
                        <Icon name='calendar check outline' />
                        <Header.Content>
                            Contributi in scadenza
                            <Header.Subheader>{anagrafica.ragioneSociale}</Header.Subheader>
                        </Header.Content>                                
                    </Header>
                </Grid.Row>
                {this.renderContributi()}
            </Grid>
        );
    }

    renderContributi() {
        if (this.props.inScadenza.length === 0) {
            return (
                <Grid.Row>
                    <Grid.Column mobile={16} tablet={15} computer={15}>
                        <Header as='h2' icon textAlign='center'>
                            <Icon name='info' circular inverted color='blue' />
                            <Header.Content>Non sono presenti contributi con scadenze</Header.Content>
                        </Header>
                    </Grid.Column>
                </Grid.Row>
            );
        }
            
        return this.props.inScadenza.map(this.renderContributo);
    }

    renderContributo(contributo: Contributo) {
        const segmentProps = {inverted: false, color: contributo.color, tertiary: false};

        const contributoSegment = this.renderContributoBody(contributo);
        const segment = React.cloneElement(contributoSegment, segmentProps);
        return (
            <Grid.Row key={contributo.acronimo}>
                <Grid.Column mobile={16} tablet={15} computer={15}>
                    {segment}
                </Grid.Column>
            </Grid.Row>
        );
    }

    renderContributoBody(contributo: Contributo) {
        return (
            <Segment>
                <Grid stackable columns='equal'>
                    <Grid.Row>
                        <Grid.Column>
                            <Header as='h3'>
                                {contributo.acronimo}
                                <Header.Subheader>{contributo.canaleContributivo}</Header.Subheader>
                            </Header>
                        </Grid.Column>
                        <Grid.Column>
                            <Header as='h3' color={contributo.color}>
                                Scadenza: {' '} {datetimeFormatter(contributo.scadenza)}
                                <Header.Subheader>{contributo.tipoScadenza} </Header.Subheader>
                            </Header> 
                        </Grid.Column>
                        <Grid.Column floated='right' textAlign='right'>
                            {this.renderImportiContributo(contributo.importi)}
                        </Grid.Column>
                    </Grid.Row>                
                </Grid>
            </Segment>
        );
    }

    renderImportiContributo(importi: ReadonlyArray<ImportoContributo>) {
        if (importi.length === 0) {
            return (<div />)
        }

        return (
            <Table compact='very' definition columns={2} unstackable basic>                                
                <Table.Body>
                    {importi.map(this.renderImportoContributo)}
                </Table.Body>
            </Table>
        );
    }

    renderImportoContributo(importo: ImportoContributo) {
        return (
            <Table.Row key={importo.tipoImporto}>
                <Table.Cell width={3}>{importo.tipoImporto}</Table.Cell>
                <Table.Cell textAlign='right'>€ {decimalFormatter(importo.importo)}</Table.Cell>
            </Table.Row>
        );
    }
}

export default connector(InScadenza);